import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home/map.png'
import _imports_1 from '@/assets/images/home/plane.png'
import _imports_2 from '@/assets/images/home/journey.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-349e0dcf")

_pushScopeId("data-v-349e0dcf")
const _hoisted_1 = { class: "overlay home-banner" }
const _hoisted_2 = { class: "banner-title home-banner__title" }
const _hoisted_3 = { class: "banner-subtitle home-banner__subtitle" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "home-banner__img home-banner__img--1",
  src: _imports_0,
  alt: "Карта мира",
  title: "Рост количества зарегистрированных иностранных туристов в Казахстане"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "home-banner__img home-banner__img--2",
  src: _imports_1,
  alt: "Самолет",
  title: "Статистика туризма в Казахстане"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "home-banner__img home-banner__img--3",
  src: _imports_2,
  alt: "Путешествие",
  title: "Путешествуйте вместе с tourstat.kz"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pages.home.banner.title')), 1),
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('pages.home.banner.subtitle')), 1),
    (!$setup.userActive)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/login",
          class: "btn default-btn default-btn--banner home-banner__link"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('commands.enter')), 1 /* TEXT */)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
})